import React, { useEffect, useState } from 'react';
import { ReferrerQueryString } from '@fff-web/fff-analytics';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { useUserContext } from '@fff-web/fff-utilities';
import manageMembershipStyles from './ManageMembership.module.css';
import ManageMembershipLink from './ManageMembershipLink';
import { LOCK_IN_RATE_PATH } from '../../../../utils/routePaths';
import { getBoxStatus } from '../../services/api/box';

import {
  CANCEL_SUBSCRIPTION_LABEL,
  REACTIVATE_MEMBERSHIP_LABEL,
  Plans,
  BOX_STATUS,
  SUBSCRIPTION_STATUS,
} from '../../../constants';

import {
  trackClickSwapForCredit,
  trackClickCancelSubscription,
  trackClickReactivateMembership,
} from './trackEvents';

import styles from '../Section.module.css';

const REFERRER_QUERY_STRING = `?referrer=${ReferrerQueryString.myAccount}`;

const ManageMembership = () => {
  const [boxStatus, setBoxStatus] = useState('');

  const flags = useFlags();
  const { userInfo } = useUserContext();
  const { user } = userInfo;
  const { subscriptionState } = user;

  const priceLockFlag = flags && flags.priceLock;
  const displayLockInRateLink = user.planCode === Plans.ANNUAL && priceLockFlag;

  const displaySwapForCredit =
    user.planCode === Plans.TRIAL
      ? subscriptionState !== SUBSCRIPTION_STATUS.ACTIVE
      : boxStatus !== BOX_STATUS.SKIPPED_INTRO;

  const clickSwapForCredit = () => {
    trackClickSwapForCredit(userInfo);
  };

  const handleCancelSubscription = () => {
    trackClickCancelSubscription(user);
  };

  useEffect(() => {
    const fetchBoxStatus = async () => {
      const { boxState } = await getBoxStatus();
      setBoxStatus(boxState);
    };

    fetchBoxStatus();
  }, []);

  return (
    <div className={`${manageMembershipStyles.container}`}>
      {subscriptionState === SUBSCRIPTION_STATUS.EXPIRED ? (
        <ManageMembershipLink
          path={`/reactivate-my-membership${REFERRER_QUERY_STRING}`}
          onClickCTA={trackClickReactivateMembership}
          title={REACTIVATE_MEMBERSHIP_LABEL}
          subtitle="Reactivate to a seasonal or annual membership today and gain
          instant access to all of the FabFitFun perks."
        />
      ) : (
        <>
          {displayLockInRateLink && (
            <ManageMembershipLink
              path={LOCK_IN_RATE_PATH}
              title="Lock in Your Rate"
              subtitle="Limited time offer. Lock in your current
              price before the membership price increases."
            />
          )}
          {displaySwapForCredit && (
            <ManageMembershipLink
              path={`/swap-for-credit${REFERRER_QUERY_STRING}`}
              onClickCTA={clickSwapForCredit}
              title="Swap for credit"
              subtitle="Swap your
              box for e-commerce credit and create your own shopping experience – so you
              decide how to shop with us!"
            />
          )}
          {subscriptionState !== SUBSCRIPTION_STATUS.CANCELED ? (
            <ManageMembershipLink
              path={`/cancel-subscription${REFERRER_QUERY_STRING}`}
              title={CANCEL_SUBSCRIPTION_LABEL}
              subtitle="By ending your account you will
                  lose access to your FabFitFun benefits."
            />
          ) : (
            <ManageMembershipLink
              path={`/reactivate-today${REFERRER_QUERY_STRING}`}
              onClickCTA={handleCancelSubscription}
              title={REACTIVATE_MEMBERSHIP_LABEL}
              subtitle="Reactivate to a seasonal or annual membership today and gain
                instant access to all of the FabFitFun perks."
            />
          )}
        </>
      )}
    </div>
  );
};

export default ManageMembership;
